import IsCurrent from './IsCurrent';
import TermType from './TermType';
import TermIdYear from './TermIdYear';
import Range from './Range';
import Name from './Name';
import Year from './Year';
import Years from './Years';
import YearsRange from './YearsRange';
import Current from './Current';
import YearWithoutInit from './YearWithoutInit';

export default {
    IsCurrent,
    TermType,
    TermIdYear,
    Range,
    Name,
    Year,
    Years,
    YearsRange ,
    Current,
    YearWithoutInit
}